import { Event } from "../../contracts";
import { GameStatus } from "sbtech-sports-data-api-contracts";

export const mapKickOffState = (x: Event) => {
    x.isInKickOffState = x.isLive && x.status === GameStatus.NotStarted;
    return x;
}
